module.exports = __webpack_public_path__ + "static/media/time_frequency-min.cf7391e6.jpg";